<!--
 * @Author: wangliang
 * @LastEditTime: 2024-03-14 16:50:53
 * @Description: 模型库树
-->
<template>
  <div>
    <el-dialog
      class="mini-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="modelTreeProps.visible"
      :title="modelTreeProps.title"
      :close-on-click-modal="false"
      @close="close(false)"
    >
      <el-form
        :model="modelTreeContextForm"
        :rules="modelTreeFormRules"
        ref="modelTreeForm"
        label-width="150px"
        :disabled="modelTreeProps.editType === 'read'"
      >
        <el-form-item :label="`${$t('工程名称')}`" prop="name">
          <el-input
            v-model="modelTreeContextForm.name"
            :type="'text'"
            :placeholder="`${$t('请输入工程名称')}`"
            size="small"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center" v-if="modelTreeProps.editType !== 'read'">
        <el-button
          size="small"
          type="primary"
          @click="save()"
          :loading="saveLoading"
          >{{ $t('保存') }}</el-button
        >
        <el-button size="small" @click="close(false)">{{
          $t('取消')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { TheEngineeringModelSceneTreeApi } from '@wiz-api/cloud-render-management'
import { pickBy, get, filter, map, split, cloneDeep } from 'lodash'

const theEngineeringModelSceneTreeApi = new TheEngineeringModelSceneTreeApi()

export default {
  name: 'OperateEngineeringTreeDialog',
  props: {
    modelTreeProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: '新增工程模型',
          editType: 'create',
        }
      },
    },
    modelTreeForm: {
      type: Object,
      default: () => {
        return {
          name: '',
        }
      },
    },
  },
  data() {
    return {
      modelTreeContextForm: {
        name: '',
      },
      // 表单保存状态
      saveLoading: false,
    }
  },
  computed: {
    modelTreeFormRules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('请输入工程名称'),
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    close(expandId) {
      this.$emit('closeModelTreeDialog', expandId)
    },
    save() {
      this.$refs.modelTreeForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          if (this.modelTreeProps.editType === 'create') {
            const query = {
              parentId: get(this.modelTreeContextForm, 'id') || null,
              name: this.modelTreeContextForm.name,
            }
            const [err] = await theEngineeringModelSceneTreeApi.create({
              body: query,
            })
            this.saveLoading = false
            if (!err) {
              this.$message.success(this.$t('新增成功'))
              this.close(get(this.modelTreeContextForm, 'id') || '')
            }
            return
          }
          const [err] = await theEngineeringModelSceneTreeApi.update(this.modelTreeContextForm.id, {
            body: this.modelTreeContextForm,
          })
          this.saveLoading = false
          if (!err) {
            this.$message.success(this.$t('修改成功'))
            this.close(this.parentId || '')
          }
        }
      })
    },
  },
  created() {
    this.modelTreeContextForm = cloneDeep(this.modelTreeForm)
  },
}
</script>
